import { IComponentOptions } from "angular";
import { TagAvatar } from "./models";

class GridFiltersTagAvatarCtrl {
  avatar: TagAvatar;
  size: "small" | "medium";
  isActive: boolean;
}

export const GridFiltersTagAvatarComponent: IComponentOptions = {
  template: `
    <img ng-if="$ctrl.avatar.picture" ng-src="{{ ::$ctrl.avatar.picture }}" alt="" class="{{::$ctrl.size}}" ng-class="{'deactivated': $ctrl.isActive === false}"/>
    <span ng-if="$ctrl.avatar.icon" class="nc-icon-outline icon" ng-class="::$ctrl.avatar.icon" ng-attr-style="background: {{ ::$ctrl.avatar.color }}"></span>
    <span ng-if="$ctrl.avatar.color && !$ctrl.avatar.icon" class="only-color" ng-class="::$ctrl.size" ng-attr-style="background: {{ ::$ctrl.avatar.color }}"></span>
    <span ng-if="$ctrl.avatar.gtmhub" class="gtmhub-logo"></span>
    <span ng-if="$ctrl.avatar.emoji" class="twa twa-lg" ng-class="::'twa-' + $ctrl.avatar.emoji"></span>
  `,
  controller: GridFiltersTagAvatarCtrl,
  bindings: {
    avatar: "<",
    size: "@",
    isActive: "=",
  },
};
